interface GetInvalidTitleOptions {
  hasUploadError?: boolean;
  accept: string;
}

interface GetInvalidHintOptions {
  hasUploadError?: boolean;
  allowedExtensions?: string;
}

/**
 * Get the error title text based on error type.
 */
export const getInvalidTitle = ({
  hasUploadError,
  accept,
}: GetInvalidTitleOptions): string => {
  if (hasUploadError) {
    return "Couldn't upload";
  }
  if (accept.includes('video')) {
    return 'Videos only!';
  }
  return 'Images only!';
};

/**
 * Get the hint text for invalid state.
 */
export const getInvalidHint = ({
  hasUploadError,
  allowedExtensions,
}: GetInvalidHintOptions): string => {
  if (hasUploadError) {
    return 'Tap to try again';
  }
  if (allowedExtensions) {
    return `Please use: ${allowedExtensions}`;
  }
  return 'Oops, wrong file type';
};
